export const SMART_LINK_DRAGGABLE = {
	CHANGEBOARD_VIEWED: 'smart-link-draggable:changeboardViewed',
} as const;

export type SmartLinkDraggableKeys =
	(typeof SMART_LINK_DRAGGABLE)[keyof typeof SMART_LINK_DRAGGABLE];

export const SmartLinkDraggableOnboardingKeys = Object.values(
	SMART_LINK_DRAGGABLE,
) as ReadonlyArray<SmartLinkDraggableKeys>;
